import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import './Chips.css';
//
// Компонент для отображения выбранной в фильтре категории или страны
//
const Chips = ({ list, onRemove }) => {

    if(list.length < 1) return null;

	return (
        <div>
            {list.map(item => (
                <span key={item.id} className='Chip'>
                    <span>
                        <span>{item.name}</span>
                        <span onClick={() => onRemove(item.id)}>
                            <FontAwesomeIcon icon={faCircleXmark}/>
                        </span>
                    </span>
                </span>
            ))}
        </div>
	);
};

Chips.propTypes = {
	onRemove: PropTypes.func,
    list: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    })).isRequired,
};

export default Chips;
